import { render, staticRenderFns } from "./importProductInfoList.vue?vue&type=template&id=2cef51c2&scoped=true"
import script from "./importProductInfoList.vue?vue&type=script&lang=js"
export * from "./importProductInfoList.vue?vue&type=script&lang=js"
import style0 from "./importProductInfoList.vue?vue&type=style&index=0&id=2cef51c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef51c2",
  null
  
)

export default component.exports